module.exports = __webpack_public_path__ + "img/iphone-frame.b55dde77.png";